export default {"src":"/_next/static/media/identity.40cd5173.svg","height":704,"width":1051};